import React from 'react';
import { Col, FormGroup, Row } from 'react-bootstrap';
import { RichTextEditor, TextBox, CheckBox, RadioButton } from 'fw/forms';
import { Label } from 'fw/components';
import { SetupTab } from 'areas/shared/pages/setup';
import * as App from 'modules/app/App'
import * as API from 'modules/app/API'

let HelpTypes = {HTML: 'HTML', URL:'URL'} ;

class HelpInfoTab extends SetupTab {
    initialForm() {
        return {
            helpUrl: "",
            helpKey: "",
            helpContent: "",            
            helpType: HelpTypes.URL,
            rowVersion: null
        }
    }

    privileges() {
        return {
            edit: App.hasPrivilege("AdminHelpSetupEdit")
        }
    }

    urls() {
        return {
            get: API.App.url('/helpSetup/getHelpInfo'),
            save: API.App.url('/helpSetup/SaveHelpInfo')
        }
    }

    getRequest(selectedId) {
        return {
            helpTopicId: selectedId
        }
    }

    saveRequest() {

        let model = {
            helpTopicId: this.props.selectedId,
            helpKey: this.state.form.helpKey,
            active: this.state.form.active,
            rowVersion: this.state.form.rowVersion
        }
        
        if (this.state.form.helpType === HelpTypes.URL)
            model.helpUrl = this.state.form.helpUrl;
        else 
            model.helpHtml = this.state.form.helpHtml;

        return model;
    }

    renderForm() {
        
        return (
            <React.Fragment>
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <Label htmlFor="helpKey" required>Screen or Tab Location</Label>
                            <TextBox name="helpKey" maxLength={128} disabled />
                        </FormGroup>
                        <FormGroup>
                            <RadioButton name="helpType" option="URL" label="Help URL"/>
                            <TextBox 
                                name="helpUrl" 
                                placeholder="Help URL"
                                maxLength={256} 
                                disabled={this.state.form.helpType !== HelpTypes.URL} />
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <Label>&nbsp;</Label>
                            <CheckBox name="active" label="Active" />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <FormGroup>
                            <RadioButton name="helpType" option="HTML" label="Help Content"/>
                            <RichTextEditor enabled={this.state.enabled} name="helpHtml"  disabled={this.state.form.helpType !== HelpTypes.HTML} />
                        </FormGroup>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}

export default HelpInfoTab;



// WEBPACK FOOTER //
// ./src/areas/admin/helpSetup/helpInfo/HelpInfoTab.js